import { Controller } from "@hotwired/stimulus"

/**
 * Scrolls the element into view on connect.
 *
 * Usage:
 *   <div data-controller="scroll-into-view"
 *        data-scroll-into-view-block-value="start"
 *        data-scroll-into-view-behavior-value="smooth">
 */
export default class extends Controller {
  static values = {
    block: { type: String, default: "start" },       // "start", "center", "end", "nearest"
    behavior: { type: String, default: "smooth" },    // "smooth", "instant", "auto"
  }

  connect() {
    requestAnimationFrame(() => {
      this.element.scrollIntoView({
        behavior: this.behaviorValue,
        block: this.blockValue,
      })
    })
  }
}
